import { jsx } from "react/jsx-runtime";
import logo_light_png from "../../assets/images/logo_light.png.js";
function LogoImage() {
  const logo_png = logo_light_png;
  return /* @__PURE__ */ jsx("picture", { children: /* @__PURE__ */ jsx(
    "img",
    {
      src: logo_png,
      alt: "logo",
      style: {
        display: "block"
      }
    }
  ) });
}
export {
  LogoImage
};
